import { ROTA_APIS } from "@/api_framework/api_config";
import {
  IRotaManagementRotaProvidersProps,
  IRotaManagementRotaProvidersResponse,
} from "@/api_framework/api_modals/Rota";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setProvider } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
type ProvidersPayload = IRotaManagementRotaProvidersProps & {
  source?: string;
};

export const useRotaShiftProvidersAPI = () => {
  const [APIError, setAPIError] = useState<AxiosError | null>(null);
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const execute = useCallback(
    async (filterParams: IRotaManagementRotaProvidersProps, source?: string) => {
      dispatch(
        setLoading({
          key: "isPWLInProgress",
          status: true,
        }),
      );

      const payload: ProvidersPayload = {
        ...filterParams,
      };

      if (source === "overbooking_v2") {
        payload.provider_category_ids = ["7"];
      }

      if (source === "rota") {
        payload.source = "rota";
      }

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(
            ROTA_APIS?.ROTA_SHIFT_PROVIDER?.baseURL ?? "",
            payload,

            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IRotaManagementRotaProvidersResponse>) => {
            if (res.data.status === true) {
              dispatch(setProvider({ data: res.data.data }));
            } else {
              //
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(setProvider({ data: [] }));
            setAPIError(e);
            // if () {
            //   toast.error("Error while fetching patient waiting list");
            // }
            if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
              // toast.success("Standard Shift has been created ");
              dispatch(setProvider({ data: [] }));
              dispatch(
                setLoading({
                  key: "isPWLInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(setProvider({ data: [] }));
            }
            // if (e.response.status === 500) {
            //   toast.error("Server error 500");
            // }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        dispatch(setProvider({ data: [] }));
      }
    },
    [dispatch],
  );
  return { APIError, execute };
};
